import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    userAgent: String,
    eventType: String,
    eventBody: Object,
  };

  connect() {
    if (!this.hasUserAgentValue) return;
  }

  sendEvent(event) {
    // Only prevent default for mobile apps
    if (this._isWebview()) {
      event.preventDefault();
      try {
        this._sendEvent();
      } catch (err) {}
    }
  }

  _sendEvent() {
    if (!this.hasEventTypeValue) return;

    const mobileEvent = {
      type: this.eventTypeValue,
      body: this.eventBodyValue || {},
    };

    if (this._isAndroidWebview()) {
      window.parent.postMessage(mobileEvent);
    } else if (this._isIOSWebview()) {
      window.webkit.messageHandlers.mobileEvent.postMessage(mobileEvent);
    }
  }

  _isWebview() {
    return this._isAndroidWebview() || this._isIOSWebview();
  }

  _isAndroidWebview() {
    return this.userAgentValue.includes('infakt-android');
  }

  _isIOSWebview() {
    return this.userAgentValue.includes('infakt-ios');
  }
}
